<div class="container"
  [class.dark]="lms.isDarkMode">
  <div class="base"></div>
  <div class="triangle"></div>
</div>
